export default __webpack_public_path__ + "static/media/smartHome.e312a247.svg";